import React, { useState } from 'react';
import Icon from '../AppIcon';
import tradesData from '../../data/trades.json';
import vaultsData from '../../data/vaults.json';

const ActivityFeed = () => {
  // Build activities from trades data
  const buildActivities = () => {
    const activities = [];
    
    // Get all trades from all vaults
    Object.entries(tradesData.trades).forEach(([vaultId, trades]) => {
      const vault = vaultsData.vaults.find(v => v.id === vaultId);
      const vaultName = vault?.name || vaultId;
      const exchange = vault?.exchange || 'Unknown';
      
      trades.forEach(trade => {
        activities.push({
          id: trade.id,
          type: 'trade',
          action: trade.type === 'short' ? 'Short' : 'Long',
          asset: trade.coin,
          amount: trade.size,
          profit: trade.profitLoss,
          profitPercent: trade.profitLossPercent,
          timestamp: trade.timestamp,
          exchange: exchange,
          botName: vaultName,
          status: trade.status,
          duration: trade.duration,
          note: trade.note
        });
      });
    });

    // Add system events
    activities.push({
      id: 'sys-001',
      type: 'system',
      message: 'Prediction Futures Bot halted due to exchange fee changes',
      severity: 'warning',
      timestamp: '2025-12-22T18:00:00Z',
      botName: 'Prediction Futures Bot'
    });

    activities.push({
      id: 'sys-002',
      type: 'alert',
      message: 'BLZ delisting trade completed with 70.56% profit',
      severity: 'success',
      timestamp: '2026-01-08T09:15:00Z',
      exchange: 'Binance'
    });

    activities.push({
      id: 'sys-003',
      type: 'alert',
      message: 'MEXC Shorting Bot detected pump on STOOL/USDT',
      severity: 'info',
      timestamp: '2026-01-17T09:05:00Z',
      exchange: 'MEXC'
    });

    activities.push({
      id: 'sys-004',
      type: 'alert',
      message: 'Detected manipulation surge on RAVE/USDT from $0.30 to $12.43',
      severity: 'warning',
      timestamp: '2026-04-14T08:35:00Z',
      exchange: 'MEXC'
    });

    activities.push({
      id: 'sys-005',
      type: 'system',
      message: 'Binance Delisting Bot moved to halted mode after latest cycle',
      severity: 'warning',
      timestamp: '2026-04-14T07:10:00Z',
      botName: 'Binance Delisting Bot'
    });

    activities.push({
      id: 'sys-006',
      type: 'system',
      message: 'Market-Implied Lighter Bot entered testing mode with live-paper signal validation',
      severity: 'info',
      timestamp: '2026-04-14T06:50:00Z',
      botName: 'Market-Implied Lighter Bot'
    });

    activities.push({
      id: 'sys-007',
      type: 'alert',
      message: 'MEXC Shorting Bot stop-out event closed at -$2,022',
      severity: 'error',
      timestamp: '2026-05-08T06:35:00Z',
      exchange: 'MEXC'
    });

    activities.push({
      id: 'sys-008',
      type: 'system',
      message: 'Spot Bitcoin ETFs posted another $500M+ daily inflow streak this week',
      severity: 'info',
      timestamp: '2026-05-07T17:10:00Z',
      exchange: 'US ETF Market'
    });

    activities.push({
      id: 'sys-009',
      type: 'system',
      message: 'SEC review of the proposed 85/15 crypto ETF listing framework remains in focus',
      severity: 'warning',
      timestamp: '2026-05-07T14:20:00Z',
      exchange: 'Regulatory'
    });

    activities.push({
      id: 'sys-010',
      type: 'system',
      message: 'Morgan Stanley outlined H2 2026 rollout plans for spot crypto access in wealth channels',
      severity: 'info',
      timestamp: '2026-05-06T20:40:00Z',
      exchange: 'Institutional'
    });

    // Capital and allocation mutations
    activities.push({
      id: 'mut-001',
      type: 'mutation',
      message: 'Capital injection recorded: +$15,000 ($7,500 Jarmo, $7,500 Steven)',
      severity: 'success',
      timestamp: '2026-05-22T06:05:00Z',
      exchange: 'Portfolio Ledger',
      amount: 15000
    });

    activities.push({
      id: 'mut-002',
      type: 'mutation',
      message: 'OlympTrade and PRDT allocations updated to $7,500 each',
      severity: 'info',
      timestamp: '2026-05-22T06:10:00Z',
      exchange: 'Testing Vaults',
      amount: 9500
    });

    activities.push({
      id: 'mut-004',
      type: 'mutation',
      message: 'Stale funds moved from halted vaults into Market-Neutral vault',
      severity: 'warning',
      timestamp: '2026-05-22T06:20:00Z',
      exchange: 'Market-Neutral Testing Bot',
      amount: 38286.02
    });

    // Market-wide drawdown event
    activities.push({
      id: 'sys-011',
      type: 'system',
      message: 'Broad crypto selloff triggered sharp drawdowns across active and testing vaults',
      severity: 'error',
      timestamp: '2026-06-04T23:30:00Z',
      exchange: 'Market'
    });

    activities.push({
      id: 'sys-012',
      type: 'alert',
      message: 'MEXC Shorting Bot squeezed by violent relief bounce, down 16% on the move',
      severity: 'error',
      timestamp: '2026-06-04T23:00:00Z',
      exchange: 'MEXC',
      performanceDelta: -16.0
    });

    activities.push({
      id: 'sys-013',
      type: 'alert',
      message: 'OlympTrade Binary Bot hit hardest in the selloff, down 20% on paper book',
      severity: 'error',
      timestamp: '2026-06-04T20:15:00Z',
      botName: 'OlympTrade Binary Bot',
      performanceDelta: -20.0
    });

    activities.push({
      id: 'sys-014',
      type: 'alert',
      message: 'Market-Implied Lighter Bot directional signals faltered, down 13%',
      severity: 'warning',
      timestamp: '2026-06-04T18:45:00Z',
      botName: 'Market-Implied Lighter Bot',
      performanceDelta: -13.0
    });

    activities.push({
      id: 'sys-015',
      type: 'alert',
      message: 'PRDT Testing Bot took a 8.5% drawdown as expiry book turned negative',
      severity: 'warning',
      timestamp: '2026-06-04T16:10:00Z',
      botName: 'PRDT Testing Bot',
      performanceDelta: -8.5
    });

    activities.push({
      id: 'sys-016',
      type: 'system',
      message: 'Market-Neutral Testing Bot held flat-to-positive through the rout, up 0.72%',
      severity: 'success',
      timestamp: '2026-06-04T15:40:00Z',
      botName: 'Market-Neutral Testing Bot',
      performanceDelta: 0.72
    });

    activities.push({
      id: 'sys-017',
      type: 'alert',
      message: 'MEXC Shorting Bot booked +$8,092 winding down positions before archival',
      severity: 'success',
      timestamp: '2026-06-10T13:50:00Z',
      exchange: 'MEXC'
    });

    activities.push({
      id: 'sys-018',
      type: 'system',
      message: 'MEXC Shorting Bot archived - MEXC integration retired and no longer supported',
      severity: 'warning',
      timestamp: '2026-06-10T15:00:00Z',
      botName: 'MEXC Shorting Bot'
    });

    activities.push({
      id: 'sys-019',
      type: 'alert',
      message: 'OlympTrade Binary Bot recovered +15% off the selloff lows',
      severity: 'success',
      timestamp: '2026-06-09T11:00:00Z',
      botName: 'OlympTrade Binary Bot'
    });

    activities.push({
      id: 'sys-020',
      type: 'system',
      message: 'OlympTrade Binary Bot paused after partial recovery',
      severity: 'warning',
      timestamp: '2026-06-11T09:00:00Z',
      botName: 'OlympTrade Binary Bot'
    });

    activities.push({
      id: 'sys-021',
      type: 'alert',
      message: 'PRDT Testing Bot clawed back +2% as the expiry book stabilized',
      severity: 'success',
      timestamp: '2026-06-09T13:00:00Z',
      exchange: 'PRDT'
    });

    activities.push({
      id: 'sys-022',
      type: 'alert',
      message: 'Market-Neutral Testing Bot added another +1.08% post-selloff',
      severity: 'success',
      timestamp: '2026-06-10T10:00:00Z',
      botName: 'Market-Neutral Testing Bot'
    });

    activities.push({
      id: 'sys-023',
      type: 'system',
      message: 'Euphoria Bot entered paper-mode validation on Euphoria Finance odds-implied signals',
      severity: 'info',
      timestamp: '2026-05-20T10:00:00Z',
      botName: 'Euphoria Bot'
    });

    activities.push({
      id: 'sys-024',
      type: 'alert',
      message: 'Euphoria Bot up +22% in paper-mode validation',
      severity: 'success',
      timestamp: '2026-06-12T14:00:00Z',
      exchange: 'Euphoria Finance'
    });

    // Sort by timestamp (newest first)
    activities.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    
    return activities;
  };

  const [activities] = useState(buildActivities);
  const [filter, setFilter] = useState('all');

  const getActivityIcon = (activity) => {
    if (activity?.type === 'trade') {
      if (activity?.status === 'open') return 'Clock';
      return activity?.profit > 0 ? 'TrendingUp' : 'TrendingDown';
    }
    if (activity?.type === 'alert') {
      return 'AlertCircle';
    }
    if (activity?.type === 'system') {
      return 'Settings';
    }
    if (activity?.type === 'mutation') {
      return 'GitBranch';
    }
    return 'Activity';
  };

  const getActivityColor = (activity) => {
    if (activity?.type === 'trade') {
      if (activity?.status === 'open') return 'text-primary';
      return activity?.profit > 0 ? 'text-success' : 'text-error';
    }
    if (activity?.type === 'alert') {
      switch (activity?.severity) {
        case 'warning':
          return 'text-warning';
        case 'error':
          return 'text-error';
        case 'success':
          return 'text-success';
        default:
          return 'text-primary';
      }
    }
    if (activity?.type === 'system') {
      switch (activity?.severity) {
        case 'warning':
          return 'text-warning';
        case 'error':
          return 'text-error';
        case 'success':
          return 'text-success';
        default:
          return 'text-primary';
      }
    }
    if (activity?.type === 'mutation') {
      switch (activity?.severity) {
        case 'warning':
          return 'text-warning';
        case 'error':
          return 'text-error';
        case 'success':
          return 'text-success';
        default:
          return 'text-primary';
      }
    }
    return 'text-primary';
  };

  const getActivityBgColor = (activity) => {
    if (activity?.type === 'trade') {
      if (activity?.status === 'open') return 'bg-primary/10';
      return activity?.profit > 0 ? 'bg-success/10' : 'bg-error/10';
    }
    if (activity?.type === 'alert' || activity?.type === 'system') {
      switch (activity?.severity) {
        case 'warning':
          return 'bg-warning/10';
        case 'error':
          return 'bg-error/10';
        case 'success':
          return 'bg-success/10';
        default:
          return 'bg-primary/10';
      }
    }
    if (activity?.type === 'mutation') {
      switch (activity?.severity) {
        case 'warning':
          return 'bg-warning/10';
        case 'error':
          return 'bg-error/10';
        case 'success':
          return 'bg-success/10';
        default:
          return 'bg-primary/10';
      }
    }
    return 'bg-primary/10';
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })?.format(value);
  };

  const formatPercent = (value) => {
    const sign = value > 0 ? '+' : '';
    return `${sign}${value?.toFixed(2)}%`;
  };

  const formatSignedCurrency = (value) => {
    const num = Number(value || 0);
    const sign = num > 0 ? '+' : '';
    return `${sign}${formatCurrency(num)}`;
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;

    const diffDays = Math.floor(diffHours / 24);
    if (diffDays < 7) return `${diffDays}d ago`;
    
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })?.format(date);
  };

  const filteredActivities = filter === 'all' 
    ? activities.slice(0, 15) // Show first 15
    : activities?.filter(activity => activity?.type === filter).slice(0, 15);

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  return (
    <div className="bg-card rounded-[10px] p-6 border border-border shadow-elevation-1 h-full flex flex-col">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Activity Feed
        </h3>
        <div className="flex items-center gap-2">
          <button
            onClick={() => handleFilterChange('all')}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium caption transition-smooth ${
              filter === 'all' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            All
          </button>
          <button
            onClick={() => handleFilterChange('trade')}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium caption transition-smooth ${
              filter === 'trade' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            Trades
          </button>
          <button
            onClick={() => handleFilterChange('alert')}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium caption transition-smooth ${
              filter === 'alert' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            Alerts
          </button>
          <button
            onClick={() => handleFilterChange('mutation')}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium caption transition-smooth ${
              filter === 'mutation' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            Mutations
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto custom-scrollbar space-y-3">
        {filteredActivities?.map((activity) => (
          <div
            key={activity?.id}
            className="flex gap-3 p-4 rounded-lg bg-muted/30 hover:bg-muted/50 transition-smooth"
          >
            <div className={`w-10 h-10 rounded-lg ${getActivityBgColor(activity)} flex items-center justify-center flex-shrink-0`}>
              <Icon 
                name={getActivityIcon(activity)} 
                size={18} 
                className={getActivityColor(activity)}
              />
            </div>

            <div className="flex-1 min-w-0">
              {activity?.type === 'trade' ? (
                <>
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <p className="text-sm font-medium text-foreground truncate">
                          {activity?.action} {activity?.asset}
                        </p>
                        {activity?.status === 'open' && (
                          <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary/10 text-primary">
                            OPEN
                          </span>
                        )}
                      </div>
                      <p className="text-xs text-muted-foreground caption truncate">
                        {activity?.botName} • {activity?.exchange}
                      </p>
                    </div>
                    <div className="text-right flex-shrink-0">
                      <p className={`text-sm font-medium data-text ${activity?.status === 'open' ? 'text-primary' : (activity?.profit > 0 ? 'text-success' : 'text-error')}`}>
                        {activity?.status === 'open' ? '~' : ''}{formatCurrency(activity?.profit)}
                      </p>
                      <p className={`text-xs data-text ${activity?.status === 'open' ? 'text-primary' : (activity?.profit > 0 ? 'text-success' : 'text-error')}`}>
                        {formatPercent(activity?.profitPercent)}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between text-xs text-muted-foreground caption">
                    <span className="data-text">
                      {formatCurrency(activity?.amount)} • {activity?.duration}
                    </span>
                    <span>{formatTime(activity?.timestamp)}</span>
                  </div>
                  {activity?.note && (
                    <p className="text-xs text-muted-foreground/70 mt-1 italic">{activity?.note}</p>
                  )}
                </>
              ) : activity?.type === 'mutation' ? (
                <>
                  <p className="text-sm font-medium text-foreground mb-1">
                    {activity?.message}
                  </p>
                  <div className="flex items-center justify-between text-xs text-muted-foreground caption">
                    <span>{activity?.exchange}</span>
                    <span>{formatTime(activity?.timestamp)}</span>
                  </div>
                  {(typeof activity?.amount === 'number' || typeof activity?.performanceDelta === 'number') && (
                    <div className="mt-2 flex items-center justify-between">
                      <span className="text-xs text-muted-foreground caption">Change</span>
                      <span className={`text-xs font-medium data-text ${activity?.severity === 'warning' ? 'text-warning' : 'text-success'}`}>
                        {typeof activity?.amount === 'number' ? formatSignedCurrency(activity?.amount) : formatPercent(activity?.performanceDelta)}
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <p className="text-sm font-medium text-foreground mb-1">
                    {activity?.message}
                  </p>
                  <div className="flex items-center justify-between text-xs text-muted-foreground caption">
                    <span>{activity?.botName || activity?.exchange}</span>
                    <span>{formatTime(activity?.timestamp)}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <button className="w-full h-9 px-4 rounded-lg bg-muted text-foreground hover:bg-muted/80 transition-smooth text-sm font-medium">
          View All Activity
        </button>
      </div>
    </div>
  );
};

export default ActivityFeed;
